import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export const Nav = ({ onCta }) => (
  <motion.header
    initial={{ y: -60, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.1 }}
    className="fixed top-0 left-0 right-0 z-50 border-b border-edge/60 bg-ink/80 backdrop-blur-xl"
    data-testid="nav-bar"
  >
    <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6 lg:px-8">
      <a href="#top" className="flex items-center gap-2.5" data-testid="nav-logo">
        <img
          src="/assets/logo-180.png"
          alt="Truvon logo"
          className="h-8 w-8"
        />
        <span className="font-display text-lg font-bold tracking-tight text-slate-50">
          Truvon
        </span>
        <span className="hidden rounded-full border border-mint/30 bg-mint-dim px-2.5 py-0.5 font-mono text-[10px] uppercase tracking-[0.18em] text-mint sm:inline-block">
          Pre-launch
        </span>
      </a>
      <button
        onClick={onCta}
        data-testid="nav-cta-button"
        className="group flex items-center gap-1.5 rounded-full bg-mint px-4 py-2 text-sm font-semibold text-ink transition-colors duration-200 hover:bg-mint-hover"
      >
        Get early access
        <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </button>
    </div>
  </motion.header>
);
